import CreditsFilterBar from './CreditsFilterBar';
import { connect } from 'react-redux';

import { creditsActions, statusFilterSel } from 'src/store/modules/credits';

const mapStateToProps = (state: any) => ({
  statusFilter: statusFilterSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  getCredits: (
    page: number,
    status: 'PENDING' | 'VOID' | 'DISPOSED',
    sortby: string
  ): any => {
    dispatch(creditsActions.getCredits(page, status, sortby));
  }
});

export const pureComponent = CreditsFilterBar;

export default connect(mapStateToProps, mapDispatchToProps)(CreditsFilterBar);
